<template>
    <div>
        <LeftNavBar
            :openNavCondogrid="currentShape"
            :highlightObj="highlightObj"
            @bulkDeleteSplit="bulkDeleteSplit"
            :splitSecondNav="true"
            :bulkSelect="true"
            :selectedValue="$store.state.condogrid.currentType"
            :accordion="true"
            :items="floorList"
            :title="selectedAppInitial"
            @opened="parentClicked"
            @accordion="childClicked"
            @optionclick="optionClick"
            @chosen="grandChildClicked"
        >
        </LeftNavBar>
    </div>
</template>

<script>
import Expander from "bh-mod/components/common/Expander";
import vueCustomScrollbar from "vue-custom-scrollbar";
import LeftNavBar from "bh-mod/components/common/LeftNavBar";
export default {
    components: { Expander, vueCustomScrollbar, LeftNavBar },
    name: "menu-left",
    data() {
        return {
            openID: "",
            floorToEdit: "",
            highlightObj: {},
            openNav: {},
        };
    },
    computed: {
		selectedAppInitial() {
            return (
                (this.$store.state.theApp &&
                    this.$store.state.theApp.media &&
                    this.$store.state.theApp.media.initial) ||
                "CGC"
            );
        },
        currentShape() {
            return this.$store.state.condogrid.currentShape;
        },
        instance() {
            return this.$store.state.instance;
        },
        lots() {
            return this.$store.getters.lots;
        },
        folders() {
            return this.$store.getters.folders;
        },
        files() {
            return this.$store.getters.allFiles;
        },
        floors() {
            return this.$store.state.condogrid.floors || [];
        },
		settings(){
			return this.$store.state.condogrid.allSettings.app
		},
        floorList() {
            let list = [
                {
                    label: "Condo Floors",
                    value: "floors",
					iconUrl: require("@/assets/sideIcons/floors.svg"),
                    options: [],
                    children: [],
                },
				{
					label: "Stack View",
					value: "stack-parent",
					iconUrl: require("@/assets/sideIcons/floors.svg"),
					options: [],
					children: [
						{
							label: "Stack",
							value: "stack",
							iconUrl: "/img/floors.853444d2.svg",
							parent: "stack-parent",
							hasGrandChild: true,
							children: [[]],
							split: [
								{
									name: "Stack Floors",
									allSelect: false,
									empty: "You have no Floors in the stack view...",
								}
							]
						}
					]
				}
            ];
            let floors = Object.values(this.$store.state.condogrid.floors);

            floors.forEach((floor) => {
                let child = {};
                child.label = floor.name;
                child.value = floor.id;
				child.iconUrl = require("@/assets/sideIcons/floors.svg"),
                child.parent = "floors";
                list[0].children.push(child);
                child.hasGrandChild = true;
                child.children = [];
                let unitList = [];
                let amenityList = [];
                child.split = [
                    {
                        name: "Units",
                        allSelect: false,
                        empty: "You have no Units on this floor...",
                    },
                    {
                        name: "Amenities",
                        allSelect: false,
                        empty: "You have no Amenities on this floor...",
                    },
                ];
                floor.siteplan?.lots?.forEach((x) => {
                    let unit = {};
                    let storeUnit = Object.values(
                        this.$store.state.condogrid.units
                    );
                    if (x.type != "info") {
                        let found;
                        if (x.units && x.units.length > 0 && typeof x.units[0] == "string") {
                            found = storeUnit.find(
                                (unit) => unit.id == x.units[0]
                            );
                        } else if (x.units && x.units.length > 0) {
                            found = x.units[0];
                        }
                        unit.label = found && found.unitNumber ? `${found.unitNumber}${found.name ? ' - ' + found.name : ''}` : 'Unit does not exist'
                        unit.value = x.id;
                        unit.parent = floor.name;
                        unit.type = "Units";

                        unit.options = [
                            { label: "Edit", value: "edit" },
                            { label: "Delete", value: "delete" },
                        ];
                        unitList.push(unit);
                    } else if (x.type == "info") {
                        let amenity = {};
                        amenity.label = x.name;
                        amenity.type = "Amenities";
                        amenity.value = x.id;
                        amenity.parent = floor.name;
                        amenity.options = [
                            { label: `Edit`, value: "edit" },
                            { label: `Delete`, value: "delete" },
                        ];
                        amenityList.push(amenity);
                    }
                });
                child.children.push(unitList);
                child.children.push(amenityList);
            });

			//setting shapes
			let shapes = this.settings?.options?.stackSettings?.shapes || [];
			console.log('shapes from sidebar', shapes);
			if (shapes.length > 0) {
				shapes.forEach(x => {
					let shape = {};
					let floor = Object.values(this.floors).find(floor => floor.id == x.floor);
					if (floor) shape.label = floor.name;
					else shape.label = 'Floor not found';
					shape.value = x.id;
					shape.parent = 'Stack';
					shape.type = 'Stack Floors';
					shape.options = [
						// { label: "Edit", value: "edit" },
						{ label: "Delete", value: "delete" },
					]
					list[1].children[0].children[0].push(shape);
				})
			}

			list[1].children[0].children[0] = list[1].children[0].children[0].sort((a, b) => {
				if (a.label > b.label) return 1;
				else if (a.label < b.label) return -1;
				else return 0;
			});
            list[0].children = list[0].children.sort((a, b) => {
                if (a.label > b.label) return 1;
                else if (a.label < b.label) return -1;
                else return 0;
            });

			console.log('List', list);
            return list;
        }
    },
    methods: {
        bulkDeleteSplit(array) {
            console.log("array", array);
			let self = this;
			this.$confirm({
				title: "Delete Selected",
				content: (h) => (
					<div>Do you want to delete the selected items?</div>
				),
				okText: "Delete",
				okType: "danger",
				cancelText: "Cancel",
				centered: true,
				async onOk() {
					let siteplanId;
					Object.values(self.floors).forEach((floor) => {
						floor.siteplan?.lots?.forEach((lot) => {
							if (array.includes(lot.id)) {
								siteplanId = floor.siteplan.id;
							}
						});
					});

					if (typeof array[0] == 'string'){
						self.$api.put(`/lots/${self.instance.id}/${siteplanId}/bulkdelete`, array).then(({ data }) => {
							self.$store.dispatch("CLOSE_DRAWER", {
								type: "deletebulk",
								data,
							});
						}).catch(err => {
							if (!err || !err.response || !err.response.status || err.response.status !== 400) {
								self.$message.error(self.$err(err))
							}
						});
					} else {
						console.log('STACK LOTS', typeof array[0]);
						let settings = JSON.parse(JSON.stringify(self.settings))
						let { shapes } = settings?.options?.stackSettings
						if (shapes) settings.options.stackSettings.shapes = shapes.filter(shape => !array.includes(shape.id));

						console.log('SETTINGS', settings);

						self.$api.post(`/settings/:instance/condogrid`, settings).then(({data}) => {
							self.$store.commit('UPDATE_ALLSETTINGS', data)
							self.$message.success('Stack Floor Shapes Deleted Successfully!')
						}).catch(err => {
							if (!err || !err.response || !err.response.status || err.response.status !== 400) {
								self.$message.error(self.$err(err))
							}
						})
					}
				},
				onCancel() {
					console.log("Cancel");
				},
			});
        },
        updateAccordion(data) {
            if (data.value == "floors") {
                this.floorList[0] = {};
            }
            if (data.value == "amenities") {
                this.floorList[1] = {};
            }
        },
        grandChildClicked(item) {
			console.log('GRAND CHILD CLICKED', item);
			this.highlightObj = item;
			console.log('HIGHLIGHT OBJ', this.highlightObj);
			if (item.parent == 'Stack'){
				this.$store.commit("SELECT_LOT_SHAPE", item.value);
				this.$store.commit("changeType", 'stack');
			} else {
				let crumbObj = {};
				Object.values(this.floors).forEach((floor) => {
					floor.siteplan.lots.forEach((lot) => {
						if (lot.id == item.value) {
							this.$store.commit("SELECT_LOT_SHAPE", lot.shapeId);
							crumbObj = lot;
						}
					});
				});
				let found = {};
				if (crumbObj.type != "info") {
					let storeUnit = Object.values(
						this.$store.state.condogrid.units
					);
					if (typeof crumbObj.units[0] == "string") {
						found = storeUnit.find(
							(unit) => unit.id == crumbObj.units[0]
						);
					} else {
						found = crumbObj.units[0];
					}
				} else if (crumbObj.type == "info") {
					found = crumbObj;
				}
				let crumbName = "";
				if (found && found.type == "info") {
					crumbName = found.name;
				} else {
					crumbName = found && found.unitNumber ? `${found.unitNumber}${found.name ? ' - ' + found.name : ''}` : 'Unit does not exist'
				}
				// this.$store.commit("SET_CRUMBS", crumbName);
			}
        },
        optionClick(item) {
			console.log('OPTION CLICK', item);
            if (
                item.optionValue == "edit" &&
                item.splitParent.name == "Units"
            ) {
                let editingLot = {};
                let floors = Object.values(this.floors);
                floors.forEach((floor) => {
                    floor.siteplan?.lots?.forEach((lot) => {
                        if (lot.id == item.itemValue) {
                            editingLot = lot;
                        }
                    });
                });
                this.$store.commit("SHOW_EDIT_LOT", editingLot);
            }

            if (
                item.optionValue == "edit" &&
                item.splitParent.name == "Amenities"
            ) {
                let editingAmenity = {};
                let floors = Object.values(this.floors);
                floors.forEach((floor) => {
                    floor.siteplan?.lots?.forEach((lot) => {
                        if (lot.id == item.itemValue) {
                            editingAmenity = lot;
                        }
                    });
                });
                this.$store.commit("SHOW_EDIT_AMENITY", editingAmenity);
            }

			if (
                item.optionValue == "edit" &&
                item.splitParent.name == "Stack Floors"
            ) {
                let editingShape = {};
				let shapeSettings = this.$store.state.condogrid?.allSettings?.app?.options?.stackSettings?.shapes || [];
				shapeSettings.forEach((shape) => {
					if (shape.id == item.itemValue) {
						editingShape = shape;
					}
				});
                this.$store.commit("SHOW_EDIT_STACK", editingShape);
            }

			if (
				item.optionValue == "delete" &&
				item.splitParent.name == "Stack Floors"
			) {
				let self = this;
				this.$confirm({
					title: "Delete Stack Floor",
					content: (h) => <div>Do you want to delete this stack floor?</div>,
					okText: "Delete",
					okType: "danger",
					cancelText: "Cancel",
					centered: true,
					async onOk() {
						let settings = JSON.parse(JSON.stringify(self.settings))
						let { shapes } = settings?.options?.stackSettings
						if (shapes) settings.options.stackSettings.shapes = shapes.filter(shape => shape.id != item.itemValue);

						console.log('SETTINGS', settings);
						console.log('ITEM VALUE', item.itemValue);

						self.$api.post(`/settings/:instance/condogrid`, settings).then(({data}) => {
							self.$store.commit('UPDATE_ALLSETTINGS', data)
							self.$message.success('Stack Floor Shape Deleted Successfully!')
						}).catch(err => {
							if (!err || !err.response || !err.response.status || err.response.status !== 400) {
								self.$message.error(self.$err(err))
							}
						})
					},
					onCancel() {
						console.log("Cancel");
					},
				});
			}

            if (
                item.optionValue == "delete" &&
                item.splitParent.name == "Amenities"
            ) {
                let self = this;
                this.$confirm({
                    title: "Delete Amenity",
                    content: (h) => (
                        <div>Do you want to delete this amenity?</div>
                    ),
                    okText: "Delete",
                    okType: "danger",
                    cancelText: "Cancel",
                    centered: true,
                    async onOk() {
                        let siteplanId;
                        Object.values(self.floors).forEach((floor) => {
                            floor.siteplan?.lots?.forEach((lot) => {
                                if (lot.id == item.itemValue) {
                                    siteplanId = floor.siteplan.id;
                                }
                            });
                        });

                        self.$api
                            .delete(
                                `/lots/${self.instance.id}/${siteplanId}/${item.itemValue}`
                            )
                            .then(({ data }) => {
                                self.$store.dispatch("CLOSE_DRAWER", {
                                    type: "delete",
                                    data,
                                });
                                // $.image_map_pro_init_editor(undefined, $.WCPEditorSettings);
                            }).catch(err => {
								if (!err || !err.response || !err.response.status || err.response.status !== 400) {
									self.$message.error(self.$err(err))
								}
							});
                    },
                    onCancel() {
                        console.log("Cancel");
                    },
                });
            }

            if (
                item.optionValue == "delete" &&
                item.splitParent.name == "Units"
            ) {
                let self = this;
                this.$confirm({
                    title: "Delete Unit",
                    content: (h) => <div>Do you want to delete this unit?</div>,
                    okText: "Delete",
                    okType: "danger",
                    cancelText: "Cancel",
                    centered: true,
                    async onOk() {
                        let siteplanId;
                        Object.values(self.floors).forEach((floor) => {
                            floor.siteplan?.lots?.forEach((lot) => {
                                if (lot.id == item.itemValue) {
                                    siteplanId = floor.siteplan.id;
                                }
                            });
                        });

                        self.$api
                            .delete(
                                `/lots/${self.instance.id}/${siteplanId}/${item.itemValue}`
                            )
                            .then(({ data }) => {
                                self.$store.dispatch("CLOSE_DRAWER", {
                                    type: "delete",
                                    data,
                                });
                                // $.image_map_pro_init_editor(undefined, $.WCPEditorSettings);
                            }).catch(err => {
								if (!err || !err.response || !err.response.status || err.response.status !== 400) {
									self.$message.error(self.$err(err))
								}
							});
                    },
                    onCancel() {
                        console.log("Cancel");
                    },
                });
            }
        },
        parentClicked(item) {
            console.log("item", item);
        },
        childClicked(item) {
			console.log('Child Clicked!');
            if (item.label != this.$store.state.condogrid.currentFloor.name) {
                this.$store.commit("SET_CRUMBS", "");
            }

            this.$store.commit("changeType", item.value);
            if (item.parent == "floors") {
                this.$store.commit("CHANGE_CURRENTFLOOR", item.value);
				if (this.$route.path != '/'){
					this.$router.push("/");
				}
			}
            if (item.parent == "amenities") {
                Object.values(this.floors).forEach((floor) => {
                    floor.siteplan?.lots?.forEach((lot) => {
                        if (lot.id == item.value) {
                            this.$store.commit("SELECT_LOT_SHAPE", lot.shapeId);
                        }
                    });
                });
            }
			if (item.parent == 'stack-parent') {
				this.$store.commit("SET_CRUMBS", "Stack View");
				this.$store.commit("changeType", 'stack');
				if (this.$route.path != '/stack'){
					this.$router.push('/stack');
				}
			}
		},
	},
	mounted() {
		this.$store.commit("SET_CRUMBS", "");
		if (this.$route.path == "/") {
			this.$store.commit("SET_CRUMBS", "");
		}
	},
	watch: {
		$route(to, from) {
			if (to.path == "/") {
				this.$store.commit("SET_CRUMBS", "");
			}
        },
    },
};
</script>
